import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useLastNameValidator,
} from '@ace-clublabs/shared-component-library';
import { defaultInputProps, getRequiredFieldSx } from '../utils';

export interface LastNameFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'last-name'>>;
  validatorProps?: Parameters<typeof useLastNameValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const LastNameField: React.FC<LastNameFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Last name';
  const validator = useLastNameValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        for='last-name'
        label={label}
        {...defaultInputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        validator={validator}
        data-testid='lastName'
        {...fieldProps}
      />
    </FormGridItem>
  );
};
